import type { Dispatch, SetStateAction } from 'react'

type ContextState = {
  seasonId: string
  categoryId: string
  view: 'table' | 'chart'
  params: Partial<{ year: string; category: string }>
}

type ContextProps = { state: ContextState; setState: Dispatch<SetStateAction<ContextState>> }

const defaultState: ContextState = {
  seasonId: '',
  categoryId: '',
  view: 'table',
  params: { year: '2025', category: 'motogp' },
}

export { defaultState, type ContextProps }
